// extracted by mini-css-extract-plugin
export var printerCard = "_au-1";
export var printerCardConfigured = "_au-2";
export var printerCardError = "_au-3";
export var printerCardsContainer = "_au-0";
export var printerIcon = "_au-8";
export var printerIconConfigured = "_au-5";
export var printerIconContainer = "_au-4";
export var printerIconError = "_au-6";
export var printerIconUnconfigured = "_au-7";
export var workstationsTableCard = "_au-9";